import { getUnlockStatus, getPayments, createSetupIntent, getPaymentMethod } from '../api/stripe';
import { getMyTier } from '../api/tiers';

export const unlockService = {
  async checkUnlockStatus() {
    try {
      return await getUnlockStatus();
    } catch {
      return { unlocked: false, hasFreeAccess: false, requiresPayment: true };
    }
  },

  async getPaymentHistory() {
    try {
      return await getPayments();
    } catch {
      return [];
    }
  },

  async createSetupIntent() {
    return createSetupIntent();
  },

  async getPaymentMethod() {
    try {
      return await getPaymentMethod();
    } catch (error) {
      if (error.response?.status === 404) return null;
      return null;
    }
  },

  async getUserTier() {
    try {
      return await getMyTier();
    } catch {
      return { tier: 'STANDARD' };
    }
  }
};

export default unlockService;
